<div class="powered-by">
    <div class="powered-by__inner">
        <h5 class="powered-by__h">
            Powered by:
        </h5>
        <div class="powered-by__img-holder">
            <a href="https://tasksoftware.com/" class="powered-by__link" title="Powered by Task.">
                <img directive-image-preload [url]="src" width="103" height="23" alt="Task" class="powered-by__img">
            </a>
        </div>
    </div>
</div>
